"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.EmptyState = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var draft_illustration_1 = require("@kaizen/draft-illustration");
var typography_1 = require("@kaizen/typography");
var EmptyState_module_scss_1 = __importDefault(require("./EmptyState.module.scss"));
var ILLUSTRATIONS = {
    positive: draft_illustration_1.EmptyStatesPositive,
    neutral: draft_illustration_1.EmptyStatesNeutral,
    negative: draft_illustration_1.EmptyStatesNegative,
    informative: draft_illustration_1.EmptyStatesInformative,
    action: draft_illustration_1.EmptyStatesAction
};
/**
 * {@link https://cultureamp.design/components/empty-state/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-empty-state--default-kaizen-site-demo Storybook}
 */
var EmptyState = function (_a) {
    var children = _a.children, id = _a.id, _b = _a.illustrationType, illustrationType = _b === void 0 ? "informative" : _b, _c = _a.layoutContext, layoutContext = _c === void 0 ? "sidebarAndContent" : _c, headingText = _a.headingText, headingProps = _a.headingProps, bodyText = _a.bodyText, straightCorners = _a.straightCorners, _d = _a.isAnimated, isAnimated = _d === void 0 ? true : _d, _e = _a.loop, loop = _e === void 0 ? false : _e, automationId = _a.automationId, classNameOverride = _a.classNameOverride, props = __rest(_a, ["children", "id", "illustrationType", "layoutContext", "headingText", "headingProps", "bodyText", "straightCorners", "isAnimated", "loop", "automationId", "classNameOverride"]);
    var IllustrationComponent = ILLUSTRATIONS[illustrationType];
    return (react_1["default"].createElement("div", __assign({ className: (0, classnames_1["default"])(classNameOverride, EmptyState_module_scss_1["default"][illustrationType], EmptyState_module_scss_1["default"].container, EmptyState_module_scss_1["default"].zen, EmptyState_module_scss_1["default"][layoutContext], straightCorners && EmptyState_module_scss_1["default"].straightCorners), id: id, "data-automation-id": automationId }, props),
        react_1["default"].createElement("div", { className: EmptyState_module_scss_1["default"].illustrationSide }, isAnimated ? (react_1["default"].createElement(IllustrationComponent, { isAnimated: true, loop: loop, classNameOverride: EmptyState_module_scss_1["default"].illustration })) : (react_1["default"].createElement(IllustrationComponent, { alt: illustrationType, classNameOverride: EmptyState_module_scss_1["default"].illustration }))),
        react_1["default"].createElement("div", { className: EmptyState_module_scss_1["default"].textSide },
            react_1["default"].createElement("div", { className: EmptyState_module_scss_1["default"].textSideInner },
                headingProps ? (react_1["default"].createElement(typography_1.Heading, __assign({ classNameOverride: EmptyState_module_scss_1["default"].heading }, headingProps))) : (react_1["default"].createElement(typography_1.Heading, { variant: "heading-3", classNameOverride: EmptyState_module_scss_1["default"].heading, tag: "div" }, headingText)),
                react_1["default"].createElement(typography_1.Paragraph, { variant: "body", classNameOverride: EmptyState_module_scss_1["default"].description }, bodyText),
                children))));
};
exports.EmptyState = EmptyState;
//# sourceMappingURL=EmptyState.js.map